import { ReactNode } from "react";
import { Redirect } from "react-router-dom";
import { useStore } from "../store/useStore";
import { LoadingSpinner } from "./LoadingSpinner";

interface OnboardingGuardProps {
  children: ReactNode;
}

export function OnboardingGuard({ children }: OnboardingGuardProps) {
  const userHouseholds = useStore((s) => s.userHouseholds);
  const loading = useStore((s) => s.loading.households);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (userHouseholds.length === 0) {
    return <Redirect to="/onboarding" />;
  }

  return children;
}
